import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from './shared/alert/alert.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { Logger } from 'src/services/core/logger/logger.service';
import { environment } from 'src/environments/environment';
import { NgIf } from '@angular/common';
import { LoaderService } from 'src/services/classes/loader/loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NgIf, RouterOutlet, LoaderComponent, AlertComponent],
})
export class AppComponent implements OnInit {
  credentials: any;

  constructor(
    private credentialService: CredentialsService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.loaderService.show();
    this.credentials = this.credentialService.credentials;

    if (environment.production) {
      Logger.enableProductionMode();
    }

    setTimeout(() => this.loaderService.hide(), 5000);
  }

  isLoggedIn = () => this.credentialService.isAuthenticated();

  hasRestaurants = () => this.credentialService.hasRestaurants();
}
